import React from "react";
import { StepProps } from "../../types";
import { PreviousInjuriesListItem } from "components/Signup/components/PreviousInjuries/PreviousInjuriesListItem";
import ChatMessage, { ChatContainer } from "ui-kit/ChatMessage/ChatMessage";
import { Typography } from "ui-kit/Typography";
import Gutter from "ui-kit/Gutter";
import { previousInjuriesItems } from "components/Signup/components/PreviousInjuries/previousInjuries";
import FlowButtons from "components/Signup/components/FlowButtons/FlowButtons";
import { useCurrentAnimal } from "components/Signup/store/selectors/animals";
import { useSignupDispatch } from "components/Signup/store/hooks";
import { updateAnimalById } from "components/Signup/store/slices/animals";
import { HealthHistoryEnum } from "components/Signup/store/state/types";
import { Trans } from "translations";

const Health = ({ previous, next, isValid, transitioning }: StepProps) => {
  const dispatch = useSignupDispatch();
  const { healthHistory, name, id } = useCurrentAnimal();

  const toggleInjury = (healthHistoryItem: HealthHistoryEnum) => {
    const history = healthHistory?.includes(healthHistoryItem)
      ? healthHistory?.filter((item) => item !== healthHistoryItem)
      : [...healthHistory!, healthHistoryItem];

    dispatch(updateAnimalById({ id, update: { healthHistory: history } }));
  };

  return (
    <ChatContainer leaving={transitioning}>
      <ChatMessage>
        <Typography color="black">
          <Trans
            i18nKey="signup.previous_injuries.talk_about_health"
            values={{ name }}
            components={[<strong key="0" />]}
          />
        </Typography>
      </ChatMessage>
      <Gutter size={2} />
      {previousInjuriesItems.map((item) => (
        <ChatMessage
          fromMe
          key={item.id}
          style={{
            opacity: item.disabled(healthHistory) ? 0.3 : 1,
            transition: "200ms",
          }}
        >
          <PreviousInjuriesListItem
            name={name ?? ""}
            onPress={() => toggleInjury(item.id)}
            active={healthHistory?.includes(item.id)}
            disabled={item.disabled(healthHistory)}
            title={item.title}
            text={item.text}
            id={item.id}
          />
        </ChatMessage>
      ))}
      <FlowButtons
        inProgress={transitioning}
        backButton={false}
        next={next}
        disabled={!isValid}
        previous={previous}
      />
    </ChatContainer>
  );
};

export default Health;
